import React from "react";

const Conditions = () => {
  return (
    <div className="w-full">
      {/*  Details */}
      <div className=" w-full ">
        <p className="text-start font-['Roboto'] text-black text-lg">
          The ISKCON vijayawada  App is fully owned by International Society of
          Krishna Consciousness (ISKCON), Hare Krishna Land, vijayawada,
          Skew Bridge, Krishna Lanka, Vijayawada - 520013
          <br />
          <br />
          Your use of the App is governed by the policies, terms, and conditions
          set forth below. Please read the following information carefully. By
          using this App or donating through the app, you indicate your
          acceptance of, and agreement to be bound by, the terms set forth
          below. If you do not agree to these terms and conditions, please do
          not use this App.
          <br />
          <br />
          These terms and conditions may be changed by ISKCON in the future. It
          is your responsibility as a user to periodically return to this page
          to review the terms and conditions for amendments. The amended terms
          shall take effect automatically the day they are posted on the App.
          Your continued use of the web site following any amendments will
          constitute agreement to such amendments. These Terms of Service were
          last revised on Aug 27, 2023.
          <br />
          <br />
          Your continued usage of the App, shall be in acceptance to the terms
          that may be updated in future with retrospective effect. In case you
          do not agree to any terms your sole remedy is to stop using the App.
        </p>
      </div>

      {/* Privacy Policy */}
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">Privacy Policy</h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          This privacy notice discloses the privacy practices for ISKCON vijayawada
           App. This privacy notice applies solely to information
          collected by this App. It will notify you of the following:
        </p>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            What personally identifiable information is collected from you
            through the App, how it is used and with whom it may be shared.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            What choices are available to you regarding the use of your data.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            The security procedures in place to protect the misuse of your
            information.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            How you can correct any inaccuracies in the information.
          </li>
        </ol>
      </div>

      {/* Information Collection */}
      <div className=" w-full ">
        <h2 className="text-2xl font-bold text-[#c61d21]">
          Information Collection, Use, and Sharing
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We are the sole owners of the information collected on this App. We
          only have access to collect information that you voluntarily give us
          via email or other direct contact from you. We will not sell or rent
          this information to anyone.
          <br />
          <br />
          We will use your information to respond to you, regarding the reason
          you contacted us. We will not share your information with any third
          party outside of our organization, other than as necessary to fulfil
          your request, e.g. to ship an order.
          <br />
          <br />
          Unless you ask us not to, we may contact you via email in the future
          to tell you about specials, new products or services, or changes to
          this privacy policy.
        </p>
      </div>

      {/* Acces and Control over Information*/}
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          Your Access to and Control Over Information
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          You may opt out of any future contacts from us at any time. You can do
          the following at any time by contacting us via the email address or
          phone number given on our App:
        </p>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            See what data we have about you, if any.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Change/correct any data we have about you.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Have us delete any data we have about you.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Express any concern you have about our use of your data.
          </li>
        </ol>
      </div>

      {/* Security*/}
      <div className=" w-full ">
        <h2 className="text-2xl font-bold text-[#c61d21]">Security</h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We take precautions to protect your information. When you submit
          sensitive information via this app, your information is protected both
          online and offline.
          <br />
          <br />
          We take precautions to protect your information. When you submit
          sensitive information via this app, your information is protected both
          online and offline.
          <br />
          <br />
          While we use encryption to protect sensitive information transmitted
          online, we also protect your information offline. Only employees who
          need the information to perform a specific job (for example, billing
          or customer service) are granted access to personally identifiable
          information. The computer servers in which we store personally
          identifiable information are kept in a highly secure environment.
          <br />
          <br />
          If you feel that we are not abiding by this privacy policy, you should
          contact our business head immediately via telephone at +91-9967591425
          or via email at info@iskcon.com
        </p>
      </div>

      {/*  Refund and Cancellation Policy */}
      <div className=" w-full ">
        <h2 className="text-2xl font-bold text-[#c61d21]">
          Refund and Cancellation Policy
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          ISKCON currently accepts donations through its Online Payment Gateway
          Facility for various charitable / social purposes. ISKCON also accepts
          the payment of "booking of our Guest House". Any payment made multiple
          times due to error, or any other kind of erroneous payment may be
          brought to the notice of the App officials and the payment would be
          refunded if the App official is satisfied with the cause and/or reason
          of error by the payee.
          <br />
          <br />
          All donations and/or payment made through the App, the acceptance of
          the same is at the sole discretion of the temple management and its
          trustees. The management reserves its sole rights to accept or cancel
          any donation and/or payment without assigning any reason thereof.
          <br />
          <br />
          Please note that donations once made cannot be charged back, except in
          cases of fraudulent use, once investigation is carried out by
          necessary governmental / Bank authorities and proofs substantiated. In
          case any donation receipt is issued against the same, that shall stand
          cancelled, and any income tax benefit so derived shall be null and
          void.
        </p>
      </div>
    </div>
  );
};

export default Conditions;
